export const KIRKS_LOADING = 'KIRKS_LOADING';
export const KIRKS_UPDATING = 'KIRKS_UPDATING';
export const ADD_KIRK = 'ADD_KIRK';
export const ADD_KIRKS = 'ADD_KIRKS';
export const KIRKS_FAILED = 'KIRKS_FAILED';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const SEARCH_KIRKS = 'SEARCH_KIRKS';
export const EDITED_KIRK = 'EDITED_KIRK';
export const GET_KIRKNUM = 'GET_KIRKNUM';
export const UPDATE_KIRKNUM = 'UPDATE_KIRKNUM';
export const INPUTS_LOADING = 'INPUTS_LOADING';
export const INPUTS_UPDATING = 'INPUTS_UPDATING';
export const ADD_INPUT = 'ADD_INPUT';
export const ADD_INPUTS = 'ADD_INPUTS';
export const INPUTS_FAILED = 'INPUTS_FAILED';
export const SEARCH_INPUTS = 'SEARCH_INPUTS';
export const EDITED_INPUT = 'EDITED_INPUT';
export const SHOW_ALL = 'SHOW_ALL';
export const SHOW_MINE = 'SHOW_MINE';
export const PWCHANGE_REQUEST = 'PWCHANGE_REQUEST';
export const PWCHANGE_SUCCESS = 'PWCHANGE_SUCCESS';
export const PWCHANGE_FAILURE = 'PWCHANGE_FAILURE';
export const FORGOTPW_REQUEST = 'FORGOTPW_REQUEST';
export const FORGOTPW_SUCCESS = 'FORGOTPW_SUCCESS';
export const FORGOTPW_FAILURE = 'FORGOTPW_FAILURE';
export const PROINPUTS_LOADING = 'PROINPUTS_LOADING';
export const PROINPUTS_UPDATING = 'PROINPUTS_UPDATING';
export const ADD_PROINPUT = 'ADD_PROINPUT';
export const ADD_PROINPUTS = 'ADD_PROINPUTS';
export const PROINPUTS_FAILED = 'PROINPUTS_FAILED';
export const SEARCH_PROINPUTS = 'SEARCH_PROINPUTS';
export const EDITED_PROINPUT = 'EDITED_PROINPUT';
export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST';
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS';
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE';
